// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-rate__counter[data-v-d8ca9746]:before{content:\"(\"}.el-rate__counter[data-v-d8ca9746]:after{content:\")\"}", ""]);
// Exports
module.exports = exports;
